import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import {
  useMediaQuery,
  useTailwindLgScreenMediaQuery,
} from "@circle-react/hooks/useMediaQuery";
import { useSpaceSidebarNotifications } from "@circle-react/hooks/useSpaceSidebarNotifications";
import { useEffect } from "react";

import { useIsMemberAreaAppShellEnabled } from "@/react/hooks/useIsMemberAreaAppShellEnabled";

import type { SpaceGroupWithSpaces } from "../Sidebar";
import { Links } from "./CommunityMenu/Links";
import { SpaceGroupList } from "./CommunityMenu/SpaceGroupList";
import { GoLivePoweredBy } from "./GoLivePoweredBy";
import { LinksWrapper } from "./LinksWrapper";
import { LogoTopSection } from "./LogoTopSection";
import { PlatformMenu } from "./PlatformMenu";
import { PlatformMenuV3 } from "./PlatformMenuV3";
import { ProfileSection } from "./ProfileSection";
import { ProfileWrapper } from "./ProfileWrapper";
import { LiveIndicator } from "./SidebarFooter";
import { SidebarV2Wrapper } from "./SidebarV2Wrapper";

export interface SidebarV2Props {
  spaceGroupWithSpaces: SpaceGroupWithSpaces[];
}

export const SidebarV2 = ({ spaceGroupWithSpaces }: SidebarV2Props) => {
  const isMemberAreaAppShellEnabled = useIsMemberAreaAppShellEnabled();
  const { currentCommunityMember, data } = usePunditUserContext();
  const isLargeScreen = useTailwindLgScreenMediaQuery();
  const isSmOrMdOrLgScreen = useMediaQuery("(max-width: 1023px)");
  const shouldShowPlatforMenu = isSmOrMdOrLgScreen;
  const shouldShowV3PlatforMenu = isLargeScreen;

  const { refetchSpaceNotifications } = useSpaceSidebarNotifications();

  useEffect(() => {
    if (currentCommunityMember) {
      void refetchSpaceNotifications();
    }
  }, [currentCommunityMember, refetchSpaceNotifications]);

  const shouldShowCommunityMenuItems =
    !!currentCommunityMember || data?.current_community?.is_private === false;

  return (
    <SidebarV2Wrapper>
      {!isLargeScreen && <LogoTopSection />}
      <LinksWrapper>
        {shouldShowPlatforMenu && <PlatformMenu />}
        {shouldShowV3PlatforMenu && <PlatformMenuV3 />}
        {shouldShowCommunityMenuItems && (
          <>
            <SpaceGroupList spaceGroupWithSpaces={spaceGroupWithSpaces} />
            <Links />
          </>
        )}
      </LinksWrapper>
      {shouldShowCommunityMenuItems && !isMemberAreaAppShellEnabled && (
        <ProfileWrapper>
          <LiveIndicator />
          {!isLargeScreen && <ProfileSection />}
          <GoLivePoweredBy />
        </ProfileWrapper>
      )}
    </SidebarV2Wrapper>
  );
};
